import axios from 'axios';

class SystemApiClass {
  async getAllImportLogs(page: number) {
    const res = await axios.get(`/api/system/${page}`);
    return res.data;
  }

  async getMessage() {
    const res = await axios.get('/api/system/message');
    return res.data;
  }

  async create(message: any) {
    const res = await axios.post('/api/system/message', message);
    return res.data;
  }
}

export const SystemApi = new SystemApiClass();
